'use client'

import { cn } from '../../../utils/cn'

export interface NotesProps {
  /**
   * Class name
   */
  className?: string

  /**
   * `full` renders the 7 lines shown when the subscription tabs are visible,
   * `simple` renders the 2 lines shown otherwise.
   */
  variant: 'full' | 'simple'

  /**
   * Destination of the 停止方法 link (full variant only)
   */
  subscriptionSupportUrl: string
}

export const Notes = ({
  className,
  variant,
  subscriptionSupportUrl,
}: NotesProps) => {
  if (variant === 'simple') {
    return (
      <div
        className={cn(
          'flex w-full flex-col text-gray-01 typography-body2',
          className,
        )}
      >
        <p>※有効期限は、購入から90日です。</p>
        <p>※支払日は、カード会社に準じます。</p>
      </div>
    )
  }

  return (
    <div
      className={cn(
        'flex w-full flex-col text-gray-01 typography-body2',
        className,
      )}
    >
      <p>
        ※ポイントの
        <span className="typography-subhead2">有効期限は購入日から９０日</span>
        です。
      </p>

      <p>
        ※12,000円未満の購入（定期購入除く）には「少額決済手数料」が一律400円（税込）かかります。但し、定期購入サービスの加入中に追加でポイントを購入する際は少額決済手数料は一切発生しません。
      </p>

      <p>※支払日は、カード会社に準じます。</p>

      <p>
        ※定期購入サービスでは、毎月選択されたプランの金額がクレジットカードより定期決済され、同プランの定期購入ポイント、定期購入特典ポイントが付与されます。
      </p>

      <p>
        ※定期購入を停止する場合、その時点で保有している定期購入特典ポイントが失効となり、利用できなくなります。なお、定期購入ポイントは引き続きご利用いただけます。
      </p>

      <p>
        ※本サイトで販売するGYYMポイントについては、利用料金のお支払いが完了した後のキャンセル、払い戻しはお受け致しません。
      </p>

      <p>
        ※定期購入サービスの停止方法は
        <a
          href={subscriptionSupportUrl}
          target="_blank"
          className="cursor-pointer underline"
          rel="noreferrer"
        >
          こちら
        </a>
        。
      </p>
    </div>
  )
}
